import { ChangeDetectorRef, Component } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { filter, takeUntil } from 'rxjs/operators';
import { SimpleTableComponent } from '../../generals/Components';
import { FaqItem } from '../../interfaces/interfaces';
import { ApiService } from '../../services/api.service';
import { ConfirmComponent } from '../confirm/confirm.component';
import { FaqEditorComponent } from '../faqeditor/faqeditor.component';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html'
})
export class FaqComponent extends SimpleTableComponent<FaqItem> {

  constructor(
    private apiServiceRef: ApiService,
    private dialogService: DialogService,
    private changeDetectionRef: ChangeDetectorRef
  ) {
    super(changeDetectionRef, apiServiceRef);
    this.endPoint = 'faq';
  }

  showFaqEditorModal(faqItemId: number = null): void {
    this.dialogService.open(FaqEditorComponent, {
      header: faqItemId !== null ? 'Gyik szerkesztése' : 'Gyik hozzáadása',
      data: {
        faqId: faqItemId
      }
    }).onClose.pipe(filter(v => v === true)).subscribe(() => {
      this.refreshTable();
    });
  }

  showFaqDeleteModal(faqItemId: number): void {
    this.dialogService.open(ConfirmComponent, {
      data: {
        title: 'Gyik törlése',
        text: 'Biztosan törölni szeretnéd ezt a gyik elemet?',
        acceptText: 'Törlés',
        declineText: 'Mégse'
      }
    }).onClose.pipe(filter(r => r === true)).subscribe(() => {
      this.apiServiceRef.deleteFaq(faqItemId).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
        this.refreshTable();
      });
    });
  }
}
